var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0088 14.2405C23.651 14.2405 25.0117 15.6012 25.0117 17.2434V20.9971C25.0117 22.6862 23.651 24 22.0088 24H3.99121C2.30206 24 0.988281 22.6862 0.988281 20.9971V17.2434C0.988281 15.6012 2.30206 14.2405 3.99121 14.2405H9.99708V16.4927H3.99121C3.56893 16.4927 3.24048 16.868 3.24048 17.2434V20.9971C3.24048 21.4194 3.56893 21.7478 3.99121 21.7478H22.0088C22.3842 21.7478 22.7595 21.4194 22.7595 20.9971V17.2434C22.7595 16.868 22.3842 16.4927 22.0088 16.4927H16.0029V14.2405H22.0088ZM7.36951 8.28152C6.94723 8.75073 6.24341 8.75073 5.82113 8.28152C5.35192 7.85924 5.35192 7.15543 5.82113 6.73314L12.2024 0.351906C12.6246 -0.117302 13.3285 -0.117302 13.7507 0.351906L20.132 6.73314C20.6012 7.15543 20.6012 7.85924 20.132 8.28152C19.9443 8.51613 19.6628 8.60997 19.3812 8.60997C19.0528 8.60997 18.7713 8.51613 18.5836 8.28152L14.1261 3.82405V16.4927C14.1261 17.1496 13.61 17.6188 13 17.6188C12.3431 17.6188 11.8739 17.1496 11.8739 16.4927V3.82405L7.36951 8.28152ZM21.2581 19.1202C21.2581 19.7771 20.7419 20.2463 20.132 20.2463C19.4751 20.2463 19.0059 19.7771 19.0059 19.1202C19.0059 18.5103 19.4751 17.9941 20.132 17.9941C20.7419 17.9941 21.2581 18.5103 21.2581 19.1202Z",
    fill: "#656565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload_icon.a2c55c61586ac82b4c0b16ffa6764b2b.svg";
export { ForwardRef as ReactComponent };